import type { Account } from '@percent/domain/iam'
import type { OptionsFilter } from '@percent/lemonade'

export type AccountSelectOption = {
  label: string
  value: string
}

export const mapAccountsToSelectOptions = (accounts: Account[] | null | undefined): AccountSelectOption[] =>
  accounts?.map(({ id, email, fullName }) => ({
    label: fullName ? `${fullName} (${email})` : email,
    value: id
  })) ?? []

export const skipClientSideFiltering: OptionsFilter = ({ options }) => options
